import type { IContact } from 'src/services/api/contacts/types';
import type { IProperty } from 'src/services/api/properties/types';

const MAX_ANCESTOR_DEPTH = 5;

/**
 * Resolve a property's effective contacts from already-fetched data, mirroring
 * the backend's `get_contacts` resolution: the property's own linked contacts
 * when it has any, otherwise those of the nearest ancestor with any linked,
 * walking at most `MAX_ANCESTOR_DEPTH` parents.
 */
export function resolvePropertyContacts(
    contacts: IContact[],
    properties: IProperty[],
    propertyId: number,
): IContact[] {
    const propertiesById = new Map(properties.map((property) => [property.id, property]));
    const linkedTo = (id: number) => contacts.filter((contact) => contact.property_ids.includes(id));

    let resolved = linkedTo(propertyId);
    let current = propertiesById.get(propertyId);
    let depth = 0;
    while (resolved.length === 0 && current?.parent_property_id != null && depth < MAX_ANCESTOR_DEPTH) {
        current = propertiesById.get(current.parent_property_id);
        if (current === undefined) {
            break;
        }
        resolved = linkedTo(current.id);
        depth += 1;
    }
    return resolved;
}
